module.exports = require('../dist/selectors/credit-cards');
